const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArror(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 0,
    fill: "#FFFFFF",
    fillOpacity: 0.009999999776482582,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.70711,5.707107Q15.847760000000001,5.566455,15.92388,5.382684Q16,5.198912,16,5Q16,4.9015086,15.98078,4.80491Q15.96157,4.708311,15.92388,4.617317Q15.88619,4.526322,15.83147,4.44443Q15.77675,4.362537,15.70711,4.292893Q15.63746,4.223249,15.55557,4.16853Q15.47368,4.113812,15.38268,4.076121Q15.29169,4.03843,15.19509,4.019215Q15.09849,4,15,4Q14.80109,4,14.61732,4.076121Q14.43355,4.152241,14.29289,4.292894L7.292893,11.29289Q7.223249,11.36254,7.168531,11.44443Q7.113812,11.52632,7.076121,11.61731Q7.03843,11.70831,7.019215,11.80491Q7,11.90151,7,12Q7,12.09849,7.019215,12.19509Q7.03843,12.29169,7.076121,12.38268Q7.113812,12.47368,7.168531,12.55557Q7.223249,12.63746,7.292893,12.70711L14.29289,19.7071Q14.43354,19.8478,14.61732,19.9239Q14.80109,20,15,20Q15.09849,20,15.19509,19.980800000000002Q15.29169,19.9616,15.38268,19.9239Q15.47368,19.886200000000002,15.55557,19.8315Q15.63746,19.776699999999998,15.70711,19.7071Q15.77675,19.6375,15.83147,19.5556Q15.88619,19.4737,15.92388,19.3827Q15.96157,19.2917,15.98078,19.1951Q16,19.0985,16,19Q16,18.801099999999998,15.92388,18.6173Q15.847760000000001,18.433500000000002,15.70711,18.2929L9.41421,12L15.706389999999999,5.707828L15.70711,5.707107L15.70711,5.707107Z",
    fillRule: "evenodd",
    fill: "#333333",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArror);
export default __webpack_public_path__ + "static/media/arror.52074dddcf1045609a3969d574528be8.svg";
export { ForwardRef as ReactComponent };